// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { DemoJoinScreen } from '../features/demo/DemoJoinScreen'
import { DemoStartScreen } from '../features/demo/DemoStartScreen'
import { text } from '../shared/routing/search'

export const Route = createFileRoute('/demo')({
  staticData: { screenId: 'DemoStartScreen', access: 'flag demo.enabled' },
  // The route key's query arguments (screens.json `args`), as the apps' LinkResolver reads them;
  // unknown keys are dropped.
  validateSearch: (search: Record<string, unknown>): { persona?: string; token?: string } => ({
    persona: text(search.persona),
    token: text(search.token),
  }),
  component: DemoRoute,
})

function DemoRoute() {
  const { persona, token } = Route.useSearch()
  // A join link (A7F2) carries a token: the second window signs in as the persona it names instead of starting a demo.
  return token ? <DemoJoinScreen token={token} /> : <DemoStartScreen persona={persona} />
}
